import Home from "./components/Home";
import Header from "./components/Header";
import './App.css';

function App() {
  return (
    <div>
      <Header />
      <Home />
    </div>
  );
}

export default App;
